<template>
	<div class="content">
        <container v-if="!loaded"><loading /></container>
        <div class="md-layout" v-if="loaded">
            <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100" style="margin-bottom:15px;display: flex;align-items: center;">
            	<h4 class="application-title" style="font-weight: bold;">{{translate(locale.new_user)}}</h4>
        	</div>
			<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-50" style="margin-bottom:15px; display: flex;">
				<container>
					<div class="md-layout">
						<div class="md-layout-item md-xsmall-size-70 md-small-size-70 md-medium-size-80 md-size-80">
							<form-input v-model="user.search" :label="locale.single_id" type="text"/>
						</div>
						<div class="md-layout-item md-xsmall-size-30 md-small-size-30 md-medium-size-20 md-size-20">
							<md-button class="md-just-icon md-primary" @click="searchUser()" style="margin-top: 28px;"><i class="material-icons">search</i></md-button>
						</div>

						<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-size-50">
							<form-input v-model="user.name" :label="locale.user_name" disabled/>
						</div>
						<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-size-50">
							<form-input v-model="user.phone_number" :label="locale.phone_number" disabled/>
						</div>
						<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-size-50">
							<form-input v-model="user.email" :label="locale.email" disabled />
						</div>
						<div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-50 md-size-50">
							<form-select v-model="user.unit_id" :label="locale.unit" :list="unit_list" />
						</div>
					</div>
				</container>
        	</div>
			<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-50" style="margin-bottom:15px; display: flex;">
				<container>
					<div class="md-layout">
						<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100" style="margin-bottom: 15px;">
							<div class="text-primary"><b>{{translate(locale.permission_setting)}}</b></div>
						</div>
						<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100" v-for="(action, index) in user.action_list">
							<div class="permission-card">
								<div class="permission-select">
									<md-checkbox class="md-primary" v-model="user.action_list[index].tick"></md-checkbox>
								</div>
								<div class="permission-title"><b>{{action.name}}</b> <br>{{translate(action.description)}}</div>
							</div>
						</div>
					</div>
				</container>
        	</div>
			<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100" style="margin-bottom:15px">
				<container>
					<div class="md-layout">
						<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
							<div class="error-text">
								<p v-for="e in errors">* {{translate(e)}}</p>
							</div>
						</div>
						<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100 text-right">
							<md-button class="md-raised md-primary"
								@click="createUser()">{{translate(locale.create_user)}}</md-button>
						</div>
					</div>
				</container>
			</div>
        </div>
    </div>

</template>

<script>
	export default {
		created() {
			// this.getSettings();
			this.getUnit();
			this.getAction();
		},

		data() {
			return {
				loaded: false,
				user: {
					search: "",
					single_id: "",
					name: "",
					phone_number: "",
					email: "",
					unit_id: "",
					action_list: []
				},
				unit_list: [],
				errors: [],
			}
		},
		methods: {
			getUnit(more = false) {
				this.$http.post(this.config.api + "/user/unit/list").then(data => {
					this.unit_list = data.body.data;
				})
			},
			getAction(more = false) {
				this.$http.post(this.config.api + "/user/action/list").then(data => {
					let list = [];
					for(let i = 0; i < data.body.data.length; i++) {
						list.push({id: data.body.data[i].id, name: data.body.data[i].name, tick: "", description: data.body.data[i].description})
					}
					this.user.action_list = list;
					this.loaded = true;
				})
			},
			searchUser() {

				this.$http.post(this.config.api + "/user/user/search_single_id", {
					id: this.user.search
				}).then(res => {
					if (res.body.status == 'success') {
						this.user.single_id = res.body.data.user.id;
						this.user.name = res.body.data.user.last_name_km + " " + res.body.data.user.first_name_km;
						this.user.phone_number = res.body.data.user.phone_number;
						this.user.email = res.body.data.user.email;
					}
				})
			},
			createUser() {

				if (!this.checkValidation()) {
					return;
				}

				this.$http.post(this.config.api + "/user/user/post", {
					user: this.user
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "You have created an account successfully.||អ្នកបានបង្កើតគណនីគ្រប់គ្រងដោយជោគជ័យ។",
							icon: 'check_circle',
							type: 'success'
						});

						this.$router.push("/users");
					}
				})
			},
			checkValidation() {
				this.errors = [];

				if (String(this.user.single_id).length <= 0) this.errors.push("Please fill in MISTI Single ID.||សូមបំពេញ MISTI Single ID។");
				if (String(this.user.unit_id).length <= 0) this.errors.push("Please fill in Role.||សូមបំពេញអង្គភាព។");

				if (this.errors.length == 0) return true;
				else return false;
			}
		}
	}
</script>
<style scoped>
	.permission-select {
		height: 30px;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-right: 25px;
		
	}
	.permission-card {
		display: flex;
		align-items: center;
		color: #353690;
		padding: 12px;
	}
</style>


// WEBPACK FOOTER //
// src/pages/Users/New.vue